<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"></i>
          </div>
          <div>
            <h2 class="clean-section-title has-text-white has-text-weight-bold">
              خدمات الحساب
            </h2>
            <h3 class="subtitle is-5 pt-20 has-text-white has-text-weight-bold">
              يمكنك من خلالها الاطلاع على رصيدك و كشف حسابك و تقديم طلبات الحصول
              على دفاتر الصكوك وغيرها من الخدمات
            </h3>
          </div>
        </div>
        <h2></h2>
        <div class="columns is-vcentered">
          <div class="column is-4">
            <router-link to="/services/account/balance">
              <div
                class="flex-card icon-card-hover wallet-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link">الاطلاع على رصيد</h3>
                <p class="card-description">
                  يمكنك من خلال هذا البند معرفة رصيد حسابك الجاري بالدينار
                  الليبي.
                </p>
              </div>
            </router-link>
          </div>

          <div class="column is-4">
            <router-link to="/services/account/statement">
              <div
                class="flex-card icon-card-hover wallet-card light-bordered padding-20"
              >
                <h3 class="card-title has-text-link is-clean">كشف حساب</h3>
                <p class="card-description">
                  يمكنك من خلالها الاطلاع على حركة حسابك خلال فترة ، والتي يظهر
                  بها تفاصيل كل حركات المبالغ المضافة والمخصومة ( إلى / من )
                  حسابك ، حيث وصف وقيمة المبلغ وتاريخ كل حركة .
                </p>
              </div>
            </router-link>
          </div>

          <!-- <div class="column is-4">
            <router-link to="/services/account/">
              <div
                class="flex-card icon-card-hover wallet-card light-bordered padding-20"
              >
                <a>
                  <h3 class="card-title has-text-link is-clean">
                    طلب دفتر صكوك
                  </h3>
                  <p class="card-description">
                    يمكنك من خلال ذلك التقدم بطلب الحصول على دفتر صكوك ، والذي
                    سيعمل الفرع على تجهيزه لكم لتجدونه جاهزا للاستلام خلال أول
                    زيارة تقومون بها للفرع .
                  </p>
                </a>
              </div>
            </router-link>
          </div> -->

          <!-- <div class="column">
            <div class="flex-card icon-card-hover wallet-card light-bordered padding-20">
              <h3 class="card-title has-text-link is-clean"> تحويل الاموال (قريباً)</h3>
              <p class="card-description">معلومات عن الخدمة</p>
            </div>
          </div>-->
        </div>

        <!-- <div class="columns is-vcentered">
          <div class="column is-4">
            <router-link to="/services/booking/withdrawal">
              <div
                class="flex-card icon-card-hover wallet-card light-bordered padding-20"
              >
                <a>
                  <h3 class="card-title has-text-link is-clean">
                    حجز موعد سحب نقدي
                  </h3>
                  <p class="card-description">
                    يمكنك من خلال ذلك حجز موعد للسحب نقدي في الفرع خاص بك
                  </p>
                </a>
              </div>
            </router-link>
          </div>
        </div> -->
      </div>

      <div
        class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
      >
        <router-link to="/portal">
          <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
            <b>عودة للرئيسية</b>
          </a>
        </router-link>
      </div>
    </div>

    <div
      id="success-overlay"
      class="modal modal-sm modal-success"
      v-bind:class="{ 'is-active': isCardModalActive }"
    >
      <div class="modal-background scaleInCircle"></div>
      <div class="modal-content scaleIn">
        <div class="flex-card simple-shadow">
          <div class="card-body">
            <div class="content pb-20">
              <h5 class="has-text-centered pb-20">قيمة رصيدك الحالي:</h5>

              <a class="button btn-align btn-hero is-default raised is-medium">
                <b>{{ balance }} دينار ليبي</b>
              </a>
            </div>
            <div
              class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
            >
              <router-link to="/portal">
                <a
                  class="button is-dark btn-align modal-dismiss is-bold is-medium"
                >
                  <b>عودة للرئيسية</b>
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        @click="isCardModalActive = false"
      ></button>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "account",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "mobi/newRequest",
      isCardModalActive: false,
      balance: null,
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: 108,
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeRequest(actionstring, action, url) {
      this.$router.push({
        name: "servicerequest",
        params: {
          requeststring: actionstring,
          requestid: action,
          requesturl: this.url,
        },
      });
    },
  },
  // created() {
  //   axios
  //     .get("vs/getCustomerNotifiction/").then(response => {

  //     })
  //     .catch(error => {

  //     });
  // }
};
</script>
